export function setObj(origin,data) {
    for (const key in origin) {
        delete origin[key]
    }
    for (const key in data) {
        origin[key] = data[key]
    }
}
export function setArr(origin,data) {//TODO 优化写法
    origin.length = 0
    for (let i = 0; i < data.length; i++) {
        origin.push(data[i])
    }
}

export function resetOption(cacheComponents, newOptionComponents){
    for (let i = 0; i < newOptionComponents.length; i++) {
        cacheComponents[i].cptOption.attribute = newOptionComponents[i].cptOption.attribute
    }
}

/**
 *  替换URL参数
 * @param url   url
 * @param arg   参数名
 * @param val   参数值
 */
export function changeUrlArg(url, arg, val){
    const pattern = arg + '=([^&]*)';
    const replaceText = arg + '=' + val;
    if(url.match(pattern)){
        let tmp = '/(' + arg + '=)([^&]*)/gi';
        tmp=url.replace(eval(tmp),replaceText);
        return tmp;
    }else{
        if(url.match('[?]')){
            return url+'&'+replaceText;
        }else{
            return url+'?'+replaceText;
        }
    }
}
